import { indexWrapCss } from "../../Main/css/Main.style";
import Header from "../header/Header";
import React, { useState } from "react";
import Footer from "../footer/Footer";
import { useNavigate } from "react-router-dom";
import usePageTitle from "../../../hooks/usePageTitle";


const Youth = () => {
    usePageTitle("청소년정책보호정책");

    const [search, setSearch] = useState<any>([]);
    const onSearchHandler = (e: any) => {
        setSearch(e.target.value);
    };

    const navigate = useNavigate();


    return (
        <>
            <div css={indexWrapCss}>
                <Header
                    onChange={onSearchHandler}
                    searchValue={search}
                    name="search"
                    activeFlag=""
                />

                <div
                    className="max-w-[1200px] w-full min-w-0 mx-auto flex flex-col gap-20 py-[120px] px-6 text-black">
                    <span className={"text-2xl font-bold"}>청소년보호정책</span>


                    <div className={"text-base"}>
                        <p>북밋(이하 "회사")은 청소년이 유해한 정보로부터 보호받고, 건강한 환경에서 서비스를 이용할 수 있도록 하기 위해 다음과 같은 청소년보호정책을 수립합니다.</p>

                        <hr className="w-full border-t border-black my-4 " />

                        <p> 제1조 (목적)</p>
                        <p> 본 정책은 정보통신망법 및 청소년 보호법 등 관련 법령에 따라, 청소년 유해 정보로부터의 보호를 목적으로 합니다.</p>

                        <hr className="w-full border-t border-black my-4 " />

                        <p> 제2조 (청소년보호를 위한 조치)</p>
                        <p> 회사는 아래와 같은 조치를 통해 청소년 보호를 위해 노력합니다.</p>
                        <p> 1. 청소년에게 유해한 콘텐츠를 포함하지 않도록 사전 검토 및 모니터링 실시</p>
                        <p> 2. 신고 기능 제공 등 유해 콘텐츠 발견 시 조치를 위한 체계 마련</p>
                        <p> 3. 청소년이 안전하게 사용할 수 있도록 서비스 설계 시 연령 고려</p>

                        <hr className="w-full border-t border-black my-4 " />

                        <p> 제3조 (유해정보에 대한 조치)</p>
                        <p> 회원이 유해정보를 게시한 경우, 회사는 다음과 같은 조치를 취할 수 있습니다:</p>
                        <p> 1. 해당 콘텐츠의 임시 차단 또는 삭제</p>
                        <p> 2. 경고, 이용 제한 등 계정 제재</p>
                        <p> 3. 필요 시 관련 기관에 신고 조치</p>


                        <hr className="w-full border-t border-black my-4 " />

                        <p> 제4조 (청소년 보호 책임자)</p>
                        <p> 회사는 다음과 같이 청소년 보호 책임자를 지정하여 관련 업무를 수행합니다.</p>
                        <p className={"pl-4"}> • 청소년 보호 책임자: 하서빈</p>
                        <p className={"pl-4"}> • 이메일: with.bookmeet@gmail.com
                        </p>
                        <p className={"pl-4"}>※ 변경 시 서비스 내 공지를 통해 고지합니다.</p>


                        <hr className="w-full border-t border-black my-4 " />

                        <p> 제5조 (정책의 변경)</p>
                        <p> 청소년보호정책은 관련 법령 변경 및 서비스 정책 반영을 위해 개정될 수 있으며, 변경 시 사전 공지합니다.</p>
                        <p> 시행일자: 2025년 5월 14일</p>


                    </div>


                    <div className="flex w-full justify-center">
                        <button
                            onClick={() => navigate("/")}
                            className="border-2 border-main bg-white px-8 md:px-[100px] py-[14px] rounded-full font-namsan text-lg text-main font-bold max-w-full"
                        >
                            홈으로 돌아가기
                        </button>
                    </div>


                </div>


            </div>


            <Footer />

        </>
    )

}

export default Youth;
